export default __webpack_public_path__ + "static/media/June2014.bfb278f0.png";